import PropTypes from 'prop-types'
import { Component, Children } from 'react'
import { METRIC, IMPERIAL, HYBRID } from './constants'
import { distanceFormatter } from './metrics/distance'
import { elevationFormatter } from './metrics/elevation'
import { durationFormatter } from './metrics/duration'
import { energyFormatter } from './metrics/energy'
import { heartRateFormatter } from './metrics/heartRate'
import { paceFormatter } from './metrics/pace'
import { speedFormatter } from './metrics/speed'
import { providerTypes, formatterTypes } from './types'

export class UnitProvider extends Component {

  static contextTypes = {
    intl: PropTypes.object,
  }

  getChildContext () {
    const { locale, system } = this.props
    const { intl } = this.context

    return {
      ...this.context,
      system: system,
      locale: locale,
      formatDistance: distanceFormatter({ locale, system, intl }),
      formatDuration: durationFormatter({ locale, system, intl }),
      formatElevation: elevationFormatter({ locale, system, intl }),
      formatEnergy: energyFormatter({ locale, system, intl }),
      formatHeartRate: heartRateFormatter({ locale, system, intl }),
      formatPace: paceFormatter({ locale, system, intl }),
      formatSpeed: speedFormatter({ locale, system, intl }),
    }
  }

  render () {
    return Children.only(this.props.children)
  }

}

UnitProvider.childContextTypes = {
  ...providerTypes,
  ...formatterTypes,
}

UnitProvider.propTypes = {
  children: PropTypes.element.isRequired,
  locale: PropTypes.string.isRequired,
  system: PropTypes.oneOf([METRIC, IMPERIAL, HYBRID]).isRequired,
}

export default UnitProvider
